import React from "react";
import { pressQuotes } from "../data/mock";

export default function PressStrip() {
  const items = [...pressQuotes, ...pressQuotes, ...pressQuotes];
  return (
    <section className="py-16 border-b border-[var(--mm-line)] overflow-hidden">
      <div className="marquee-track">
        {items.map((p, i) => (
          <div key={i} className="flex items-center gap-8 px-10 shrink-0">
            <span className="font-display italic text-2xl md:text-3xl text-[var(--mm-cream)] whitespace-nowrap">
              “{p.quote}”
            </span>
            <span className="text-[var(--mm-accent)] text-xs tracking-[0.3em] uppercase whitespace-nowrap">— {p.source}</span>
            <span className="text-[var(--mm-cream-muted)]">•</span>
          </div>
        ))}
      </div>
    </section>
  );
}
